export default __webpack_public_path__ + "static/media/discord-sm.c24214b3.svg";